import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@mui/material'
import { styled } from '@mui/material/styles'

/**
 * Styled MUI Button component with consistent Gaia styling
 */
const StyledButton = styled(Button)(({ theme, color }) => ({
  marginBottom: theme.spacing(1),
  marginRight: theme.spacing(1),
  '&.MuiButton-contained': {
    backgroundColor: color === 'error' ? theme.palette.error.main : theme.palette.primary.main,
    color: '#ffffff',
    '&:hover': {
      backgroundColor: color === 'error' ? theme.palette.error.dark : theme.palette.primary.dark,
    },
    '&:disabled': {
      backgroundColor: theme.palette.action.disabledBackground,
      color: theme.palette.action.disabled,
    },
  },
  '&.MuiButton-outlined': {
    borderColor: color === 'error' ? theme.palette.error.main : theme.palette.primary.main,
    color: color === 'error' ? theme.palette.error.main : theme.palette.primary.main,
    '&:hover': {
      backgroundColor: color === 'error' ? theme.palette.error.main : theme.palette.primary.main,
      color: '#ffffff',
    },
    '&:disabled': {
      borderColor: theme.palette.action.disabled,
      color: theme.palette.action.disabled,
    },
  },
  '&.MuiButton-text': {
    color: color === 'error' ? theme.palette.error.main : theme.palette.primary.main,
    '&:hover': {
      backgroundColor: color === 'error' ? theme.palette.error.light : theme.palette.primary.light,
    },
    '&:disabled': {
      color: theme.palette.action.disabled,
    },
  },
}))

/**
 * Shared MUI Button wrapper component
 * Replaces muicss Button pattern with consistent styling
 */
export default function MuiButton ({
  children,
  className,
  variant = 'contained',
  color = 'primary',
  size = 'medium',
  disabled = false,
  onClick,
  ...otherProps
}) {
  return (
    <StyledButton
      className={className}
      variant={variant}
      color={color}
      size={size}
      disabled={disabled}
      type="button"
      onClick={onClick}
      {...otherProps}
    >
      {children}
    </StyledButton>
  )
}

MuiButton.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['contained', 'outlined', 'text']),
  color: PropTypes.oneOf(['primary', 'secondary', 'error', 'info', 'success', 'warning']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
}
